import {
  GallerySingleDrop,
  InventorySingleDrop,
  PromoDrop,
  SingleDropLandingInfo,
} from '@/types/singleDrop';
import https from '@/lib/utils/https';
import { accessToken } from '../utils/helpers';

type GetSingleDropsReq = {
  params?: {
    limit?: number
  }
};

type GetSingleDropsResp = {
  drops: GallerySingleDrop[];
};

type GetInventorySingleDropsResp = {
  single_drops: InventorySingleDrop[];
};

const getSingleDrops = async (req?: GetSingleDropsReq) => {
  let params: GetSingleDropsReq['params'] = { limit: 100 };

  if (req?.params) {
    params = { ...req.params };
  }

  const resp = await https({}).get<GetSingleDropsResp>('/v1/single_drops', { params });
  return resp.data.drops;
};

const getDropPromotions = async (): Promise<PromoDrop[]> => {
  const { data } = await https({}).get<{ drops: PromoDrop[] }>('/v1/promotions');

  return data.drops;
};

const getInventorySingleDrops = async (req?: GetSingleDropsReq) => {
  let params: GetSingleDropsReq['params'] = { limit: 100 };

  if (req?.params) {
    params = { ...req.params };
  }

  const token = accessToken.get();
  const resp = await https({ token }).get<GetInventorySingleDropsResp>('/v1/inventory/single_drops', { params });
  return resp.data.single_drops;
};

const getDropClaimInfo = async (dropSlug: string) => {
  const token = accessToken.get();

  const { data } = await https({ token }).get<SingleDropLandingInfo>(`/v1/drop/${dropSlug}/landing/info`);

  return data;
};

const postClaimDrop = async (dropSlug: string) => {
  const token = accessToken.get();
  const resp = await https({ token }).post(`/v1/drop/${dropSlug}/landing/claim`);

  return resp.data;
};

const postClaimDropItem = async (dropId: string, itemId: number) => {
  const token = accessToken.get();
  const resp = await https({ token }).post(`/v1/drop/${dropId}/items/${itemId}/claim`);
  return resp.data;
};

const dropsApi = {
  getSingleDrops,
  getDropPromotions,
  getInventorySingleDrops,
  postClaimDrop,
  postClaimDropItem,
  getDropClaimInfo,
};

export default dropsApi;
